/**
 * Génère une couleur unique et cohérente à partir d'une string
 * Utilise une palette prédéfinie inspirée des couleurs de la plateforme
 */
function stringToColor(str: string): string {
  if (!str) return "#A0AEC0"; // primary-400

  // Palette basée sur le thème Tailwind (primary/secondary/ternary)
  const palette = [
    "#A0AEC0", // primary-400
    "#718096", // primary-500
    "#4A5568", // primary-600
    "#2D3748", // primary-700
    "#5CC6FF", // secondary-300
    "#24B2FF", // secondary-400
    "#009FED", // secondary-500
    "#007BBD", // secondary-600
    "#005D8F", // secondary-700
    "#BEDE7C", // ternary-300
    "#ABD558", // ternary-400
    "#98CC33", // ternary-500
    "#7AA329", // ternary-600
  ];

  // Hash simple de la string
  let hash = 0;
  for (let i = 0; i < str.length; i += 1) {
    // eslint-disable-next-line no-bitwise
    hash = str.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Sélectionner une couleur de la palette basée sur le hash
  const index = Math.abs(hash) % palette.length;
  return palette[index];
}

export default stringToColor;
